import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { get } from '../../utils/networking';

interface SlackChannel {
  id: string;
  name: string;
  isPrivate: boolean;
}

interface SlackOAuthCallbackParams {
  code: string;
  state: string;
}

interface SlackOAuthCallbackResponse {
  channels: SlackChannel[];
  slackWorkspaceId: number;
  workspaceName: string;
}

const handleSlackOAuthCallback = async (params: SlackOAuthCallbackParams): Promise<SlackOAuthCallbackResponse> => {
  const query = new URLSearchParams({
    code: params.code,
    state: params.state,
  });
  return get<SlackOAuthCallbackResponse>(
    `/api/integrations/slack/auth/callback?${query.toString()}`
  );
};

export const useHandleSlackOAuthCallback = (
  options?: Omit<UseMutationOptions<SlackOAuthCallbackResponse, Error, SlackOAuthCallbackParams>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: handleSlackOAuthCallback,
    ...options,
  });
};
